import React, { useEffect } from "react";

import {Box, Button, Typography, Link} from "@mui/material";

import MaskSelectorToolStyles from "./MaskSelectorToolStyles";
import {useTranslation} from "react-i18next";
import ScanIconBar from "./ScanIconBar";

import BulletPoint from "./BulletPoint"

import { sendGAPageView } from "ui-common/GoogleAnalytics";

const ScanHelpPage = ({ handlePrevious, handleManual }) => {

    const { t } = useTranslation("pages.MaskSelectorTool.ScanHelpPage");
    const { t: tCommon } = useTranslation("pages.MaskSelectorTool.MaskSizing");

    const heading = t("heading");
    const subHeading = t("watchVideo");
    const manualMeasure = t("manualMeasure");
    const prevButton = tCommon("prevButton");
    const tip1 = t("tip1");
    const tip2 = t("tip2");
    const tip3 = t("tip3");

    const {classes} = MaskSelectorToolStyles();

    useEffect(() => {
        sendGAPageView("ScanHelpPage");
    }, []);

    return (
        <>
            <Box className={classes.mainBox} mb="57px">

                <Box className={classes.topTextBox} >
                    <Typography className={`${classes.res_heading5} ${classes.noOutline}`} tabIndex="0" aria-label={heading}>{heading}</Typography>
                </Box>

                <ScanIconBar iconSize={62} faceIconHeight={72} labelsOnTop={true}/>

            </Box>

            <Box className={classes.tipBox} pb="20px">
                <Box className={classes.tipsContentBox} pl="20px" pr="20px" >
                    <Box mb="20px">
                        <Typography className={` ${classes.boldText} ${classes.res_heading6} ${classes.noOutline}` } tabIndex="0" aria-label={subHeading}>{subHeading}</Typography>
                    </Box>

                    <BulletPoint className={classes.res_small_paragraph} number="1" message={tip1} />
                    <BulletPoint className={classes.res_small_paragraph} number="2" message={tip2} />
                    <BulletPoint className={classes.res_small_paragraph} number="3" message={tip3} />

                </Box>
            </Box>

            <Box className={classes.mainBox}>

                <Box className={ `${classes.centeredBox} ${classes.buttonBox} ${classes.zeroBottomMargin}` }
                     mb={0} mt="20px" >
                    <Button disableRipple
                            variant="contained"
                            color="secondary"
                            onClick={handlePrevious}
                    >{prevButton}</Button>
                </Box>

                <Box sx={{mb:20}} className={classes.topTextBox} >
                    <Typography className={classes.res_standaloneLink}>
                        <Link href="#" onClick={handleManual}  className={classes.res_standaloneLink}>
                            {manualMeasure}
                        </Link>
                    </Typography>
                </Box>

            </Box>
        </>
    )
}

export default ScanHelpPage;